//attach to selling plan changes to hide/show addon
document.addEventListener('DOMContentLoaded', () => {
  const addonContainer = document.querySelector('.product__addon');
  const productForms = document.querySelectorAll('product-form form');

  if (productForms.length === 0 || !addonContainer) return;

  const addonCheckbox = addonContainer.querySelector('.product__addon-checkbox');
  const addonATCButton = addonContainer.querySelector('.product__addon-atc-button');
  const viewMore = addonContainer.querySelector('.view-offer-label a');
  const addonDetails = addonContainer.querySelector('.product__addon-details');
  const addonClose = addonContainer.querySelector('.product__addon-close');

  const addonVariantId = addonCheckbox?.dataset.variantId;
  const limitQty = addonCheckbox?.dataset.limitQty;
  const variantOptions = document.querySelector('.product-form__input');
  const sellingPlanSelect = document.querySelector('select[name="selling_plan"]');
  const sellingPlanRadios = document.querySelectorAll('input[name="selling_plan"]');
  const purchaseOptionRadios = document.querySelectorAll('input[name="purchase_option"]');

  //attach listeners to product forms
  productForms.forEach((productForm) => {
    productForm.addEventListener('submit', () => {
      if (!addonCheckbox || !addonCheckbox.checked || !addonVariantId) return;

      addAddonToCart();
    });
  });

  function addAddonToCart() {
    //if limit quantity, check if item already in cart
    checkItemInCart().then((isInCart) => {
      if (isInCart && limitQty) return;
      // Add addon after main product (with delay)
      setTimeout(async () => {
        try {
          await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [
                {
                  id: addonVariantId,
                  quantity: 1,
                  properties: {
                    _is_addon: 'true',
                    _limit_qty: limitQty, // Hidden property (starts with _)
                  },
                },
              ],
            }),
          });

          // Trigger cart refresh
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.renderContentsDrawer === 'function') {
            cartDrawer.renderContentsDrawer();
          }
        } catch (error) {
          console.error('Addon add failed:', error);
        }
      }, 600);
    });
  }

  function updateAddonVisibility() {
    setTimeout(() => {
      let shouldShowAddon = false;

      // Check selling plan radios
      if (sellingPlanRadios.length > 0) {
        sellingPlanRadios.forEach((radio) => {
          if (radio.checked && radio.value.length === 0) {
            shouldShowAddon = true;
          }
        });
      }

      // Check purchase option radios
      if (!shouldShowAddon && purchaseOptionRadios.length > 0) {
        purchaseOptionRadios.forEach((radio) => {
          if (radio.checked && radio.value !== 'subscription') {
            shouldShowAddon = true;
          }
        });
      }

      // Check selling plan select
      if (!shouldShowAddon && sellingPlanSelect && !sellingPlanSelect.value) {
        shouldShowAddon = true;
      }

      // Apply the result
      if (shouldShowAddon) {
        addonContainer.classList.add('visible');
      } else {
        addonContainer.classList.remove('visible');
        checkItemInCart().then((isInCart) => {
          if (!isInCart) addonCheckbox.checked = false;
        });
      }
    }, 0); // use 0 in order to let other event handlers run first
  }

  async function checkItemInCart() {
    //get cart
    const response = await fetch(window.Shopify.routes.root + 'cart.js', {
      cache: 'no-store', // Optional: prevents the browser from using a cached response
    });

    if (!response.ok) {
      throw new Error(`Failed to get cart: ${response.status} ${response.statusText}`);
    }

    const cart = await response.json();

    // 2. Access the items array in the cart data
    const cartItems = cart.items;

    const variantFound = cartItems.some((item) => {
      // Ensure strict comparison by converting both to the same type (e.g., number)
      return Number(item.variant_id) === Number(addonVariantId);
    });

    return variantFound;
  }

  function hideShowAddonDetails() {
    // Toggle visibility of addon details
    if (addonDetails.classList.contains('visible')) {
      addonDetails.classList.remove('visible');
    } else {
      addonDetails.classList.add('visible');
    }
  }

  if (!viewMore || !addonDetails || !addonClose) return;
  addonClose.addEventListener('click', function () {
    hideShowAddonDetails();
  });

  viewMore.addEventListener('click', function (e) {
    e.preventDefault();
    hideShowAddonDetails();
  });

  // Initial check on page load
  updateAddonVisibility();

  // Listen for changes only on relevant elements
  if (sellingPlanSelect) {
    attachChangeEventListener(sellingPlanSelect);
  }

  if (sellingPlanRadios.length > 0) {
    attachChangeEventListener(sellingPlanRadios);
  }

  if (purchaseOptionRadios.length > 0) {
    attachChangeEventListener(purchaseOptionRadios);
  }

  if (variantOptions) {
    attachChangeEventListener(variantOptions);
  }

  function attachChangeEventListener(e) {
    if (e.length > 1) {
      e.forEach((el) => {
        el.addEventListener('change', updateAddonVisibility);
      });
      return;
    }

    e.addEventListener('change', updateAddonVisibility);
  }

  //attach listener to addon atc button
  if (addonATCButton) {
    addonATCButton.addEventListener('click', (e) => {
      e.preventDefault();
      if (!addonCheckbox) return;
      addonCheckbox.checked = true;
      hideShowAddonDetails();
    });
  }
});
